// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { HashTable } from "./HashTable.js";

export let HashtableLightCount = function ()
{
    HashTable.call(this);

    this.hasValues = false;
}
HashtableLightCount.prototype = Object.create(HashTable.prototype);

Object.defineProperty(HashtableLightCount.prototype, "HasValues", {
    get: function () { return this.hasValues; },
    set: function (value)
    {
        this.hasValues = value;
    }
});

HashtableLightCount.prototype.Set = function (key, value)
{
    HashTable.prototype.Set.call(this, key, value);
    this.HasValues = true;
    return this.Get(key);
}

HashtableLightCount.prototype.Clear = function (key)
{
    HashTable.prototype.Clear.call(this, key);
    this.HasValues = false;
}

Object.defineProperty(HashtableLightCount.prototype, "Count",
    {
        get: function () { return this.counter; }
    });

